﻿// Faux links to create a larger clickable area.
// Should not affect keyboard focus or screen readers.

export default class AccessibleClickAreasHandler {
    constructor() {
        this.eventListener = "";
        this.setUpEventListeners();
    }

    setUpEventListeners() {
        const fauxLinks = document.querySelectorAll('[data-faux-href]');
        Array.prototype.forEach.call(fauxLinks, function (fauxLink) {
            let link = fauxLink.getAttribute('data-faux-href');

            fauxLink.onclick = function (e) {
                if (e.target.nodeName !== 'A') {
                    window.location.href = link;
                }
            };
        });
    }
}
